import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const CallToAction = () => {
  return (
    <section className="py-16 bg-primary text-white">
      <div className="container-custom">
        <motion.div 
          className="text-center max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Prêt à développer votre produit sur le marché canadien?
          </h2>
          <p className="text-xl mb-8">
            Contactez notre équipe aujourd'hui pour discuter de vos besoins et découvrir comment DZF Distribution peut vous aider à réussir au Canada.
          </p>
          <Link 
            to="/contact" 
            className="inline-block bg-white text-primary font-medium px-8 py-4 rounded-md hover:bg-gray-100 transition-colors duration-300"
          >
            Contactez-nous maintenant
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default CallToAction; 